import YYSelect from './select.vue'
import YYOption from './option.vue'
import YYOptionGroup from './option-group.vue'

YYSelect.YYOption = YYOption
YYSelect.YYOptionGroup = YYOptionGroup

export { YYSelect, YYOption, YYOptionGroup }
export default YYSelect